import { useMutation } from "@tanstack/react-query";

import { useAxios, useApiResponseParser } from "../";

export default function useTask() {
    const { axiosPrivate } = useAxios();
    const { parseSuccessResponseData, parseErrorResponseData } = useApiResponseParser();

    function useListSubtask() {
        return useMutation({
            mutationFn: (params: any) => axiosPrivate.get(`/v1/task/list`, { params }).then(parseSuccessResponseData),
        });
    }

    function useListSubtasks() {
        return useMutation({
            mutationFn: (params: any) =>
                axiosPrivate.get(`/v1/task/subtasks`, { params }).then(parseSuccessResponseData),
        });
    }

    function useCreate() {
        return useMutation({
            mutationFn: (parameters: any) =>
                axiosPrivate.post(`/v1/task/create`, parameters).then(parseSuccessResponseData),
        });
    }

    function useListByProjectId() {
        return useMutation({
            mutationFn: (params: any) => axiosPrivate.get(`/v1/task/list`, { params }).then(parseSuccessResponseData),
        });
    }

    function useListAssets() {
        return useMutation({
            mutationFn: (params: any) => axiosPrivate.get(`/v1/task/assets`, { params }).then(parseSuccessResponseData),
        });
    }

    function useUploadAsset() {
        return useMutation({
            mutationFn: (params: any) => axiosPrivate.post(`/v1/task/upload`, params).then(parseSuccessResponseData),
        });
    }

    function useUpdate() {
        return useMutation({
            mutationFn: (params: any) => axiosPrivate.post(`/v1/task/update`, params).then(parseSuccessResponseData),
        });
    }

    function usePatch() {
        return useMutation({
            mutationFn: (params: any) => axiosPrivate.patch(`/v1/task/update`, params).then(parseSuccessResponseData),
        });
    }

    return { useListSubtask, useListSubtasks, useListByProjectId, useUpdate, usePatch, useListAssets, useUploadAsset, useCreate };
}
